import { sponsor1, sponsor2, sponsor3 } from "../asset";
import externalLinks from "./externalLinks";

const sponsorsInfo = [
    {
        name: "Evolution Sport Therapy",
        image: sponsor1,
        link: externalLinks.sponsor1,
    },
    {
        name: "Nature's Essence",
        image: sponsor2,
        link: externalLinks.sponsor2,
    },
    {
        name: "Tzafora Luxury Ballroom Jewelry",
        image: sponsor3,
        link: externalLinks.sponsor3,
    }
];

export default sponsorsInfo;